module.exports = __webpack_public_path__ + "static/media/Places-11.aa94b3a9.jpg";